import { addMonths, subMonths, startOfWeek, max, addDays } from "date-fns";

// Hard floor: schedules and time off data is only trusted from this date onwards.
const CUMULATIVE_HOURS_HARD_FLOOR = new Date(2025, 11, 29);

// Standard full-time weekly hours used as the baseline when scaling vacation entitlement for part-time agreements.
export const FULL_TIME_WEEKLY_HOURS = 40;

// Rolling 14-month window aligned to Monday, never before the hard floor.
// HR must reconcile and pay extra hours by December each year;
// the 14-month window provides a buffer until end of January.
export const getCumulativeStartDate = () => {
    const fourteenMonthsAgo = subMonths(new Date(), 14);
    const mondayAligned = startOfWeek(fourteenMonthsAgo, { weekStartsOn: 1 });
    const effectiveStart = max([CUMULATIVE_HOURS_HARD_FLOOR, mondayAligned]);
    return effectiveStart;
};

export const getExtraHoursPaidStart = () => {
    const startDate = addMonths(getCumulativeStartDate(), 1);
    return { year: startDate.getFullYear(), month: startDate.getMonth() + 1 };
};

// Lifetime window: everything since the last reconciliation checkpoint (its day + 1), never before
// the hard floor. With no snapshot yet, falls back to the hard floor (identical to today's behaviour).
export const getLiveWindowStart = (lastCheckpointDate: Date | null) => {
    if (!lastCheckpointDate) {
        return CUMULATIVE_HOURS_HARD_FLOOR;
    }
    const dayAfterCheckpoint = addDays(lastCheckpointDate, 1);
    const start = max([CUMULATIVE_HOURS_HARD_FLOOR, dayAfterCheckpoint]);
    return start;
};
